export default __webpack_public_path__ + "static/media/02.2138fb41.mp3";